import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Recurrence, RecurrenceDialogData, RecurrenceLogMapped } from '@interfaces';
import moment from 'moment-timezone';
import { CreateRecurrenceLogsService } from './services/create-recurrence-logs.service';

@Component({
  selector: 'tab-historic',
  templateUrl: './tab-historic.component.html',
  styleUrls: ['./tab-historic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabHistoricComponent implements OnInit {
  public readonly todayDate = moment().format('DD/MM/YYYY');
  public readonly yesterdayDate = moment().subtract(1, 'days').format('DD/MM/YYYY');

  public recurrenceLogsMapped: RecurrenceLogMapped[] = [];
  public recurrence: Recurrence;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: RecurrenceDialogData,
    private createRecurrenceLogs: CreateRecurrenceLogsService,
  ) {
    this.recurrence = this.dialogData.recurrence;
  }

  async ngOnInit(): Promise<void> {
    this.recurrenceLogsMapped = this.createRecurrenceLogs.listRecurrenceLogsMapped(this.recurrence);
  }
}
